import { render } from "./InstructorHeader.vue?vue&type=template&id=3696d1ff&scoped=true"
import script from "./InstructorHeader.vue?vue&type=script&lang=js"
export * from "./InstructorHeader.vue?vue&type=script&lang=js"

import "./InstructorHeader.vue?vue&type=style&index=0&id=3696d1ff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3696d1ff"]])

export default __exports__